define('components/course/models/text-image-component',["components/course/models/slide-type/base"],
    function(BaseCourseModel) {
        "use strict";

        /**
         * Model for Text Image Component
         * @class TextImageComponentModel
         * @extends BaseCourseModel
         * @type Object
         * @constructor
         */
        var TextImageComponentModel = BaseCourseModel.extend({

            /**
             * Sets defaults from model
             *
             * @method defaults
             * @private
             * @return {Object} Defaults if not set by user
             */
            "defaults": function() {
                var baseDefaults = BaseCourseModel.prototype.defaults.apply(this, arguments),
                    defaults = {
                        /**
                         * Stores the collection of text, title and image component models
                         * @attribute textImageComponentModelCollection
                         * @type Object
                         * @default null
                         */
                        "textImageComponentModelCollection": null,

                        /**
                         * Stores the last component position
                         * @attribute lastComponentPosition
                         * @type Object
                         */
                        "lastComponentPosition": {
                            "left": TextImageComponentModel.DEFAULT_VALUES.COMPONENT_LEFT,
                            "top": TextImageComponentModel.DEFAULT_VALUES.COMPONENT_TOP
                        }
                    };

                return _.extend(baseDefaults, defaults);
            }

        }, {
            "DEFAULT_VALUES": {
                "COMPONENT_LEFT": 0,
                "COMPONENT_TOP": 30
            }
        });
        return TextImageComponentModel;
    });

